var exports = {
  "K": "xfb577c5e--eba1bc--icon",
  "w": "xfb577c5e--eba1bc--logo",
};

module.exports = exports;
